<div ng-include="'navigation/primary-navigation.tpl.html'"></div>
<div ng-if="navigation.isSecondaryNavigationOpen" class="secondary-navigation hidden-xs" ng-class="{'sn-open': navigation.isSecondaryNavigationOpen}" ng-include="'navigation/secondary-navigation.tpl.html'"></div>
<div ng-if="navigation.isMobileSecondaryNavigationOpen" class="secondary-navigation visible-xs" ng-class="{'sn-open': navigation.isMobileSecondaryNavigationOpen}" ng-include="'navigation/secondary-navigation.tpl.html'"></div>


